module.exports = {
  i18n: {
    defaultLocale: 'de',
    locales: ['en', 'de', 'fr'],
  },
  returnNull: false,
};
